import React, {useState, useEffect} from 'react';
import {bindActionCreators} from 'redux';
import {Route, Switch, useParams} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import Footer from './components/invoice/Footer';
import HeaderInvoive from './components/invoice/HeaderInvoive';
import {hideLoading, showLoading} from '../redux/actions/loadingActions';
import {loadOrderInfo} from '../redux/actions/orderActions';
import InvoicePage from '../pages/web_pay/invoice/InvoicePage';
import PaymentMethod from '../pages/web_pay/payment_method/PaymentMethod';
import CreditCard from '../pages/web_pay/credit_card/CreditCard';
import Tips from '../pages/web_pay/tips/Tips';
import WebPaymentSuccessPage from '../pages/web_pay/success_payment/WebPaymentSuccessPage';

import './invoiceLayout.scss';

function InvoiceLayout({currentLanguageId, orderInfo, loadOrderInfo, hideLoading, showLoading, t}) {
  const { branchId, orderId } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchData = async () => {    
    showLoading();
    await loadOrderInfo(branchId, orderId, currentLanguageId);
    setIsLoaded(true);
    hideLoading();
  };

  useEffect(() => {
    fetchData();
  }, [currentLanguageId]);

  return (
    <div className="ipos-web-pay">
      <HeaderInvoive t={t} />
      <section className={`content ${!isLoaded ? "content-empty" : ""}`}>
        {isLoaded && (
          <Switch>
            <Route exact path="/:branchId/invoice/:orderId" component={InvoicePage}/>
            <Route exact path="/:branchId/invoice/:orderId/payment-method" component={PaymentMethod} />
            <Route exact path="/:branchId/invoice/:orderId/credit-card" component={CreditCard} />
            <Route exact path="/:branchId/invoice/:orderId/tips" component={Tips} />
            <Route exact path="/:branchId/invoice/:orderId/success-payment" component={WebPaymentSuccessPage} />
          </Switch>
        )}
      </section>
      <Footer />
    </div>
  );
}

const mapStateToProps = (state) => {
  const {
    currentLanguageId,
    branchInfo,
    orderInfo
  } = state;

  return {
    currentLanguageId,
    branchInfo,
    orderInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      hideLoading, showLoading,
      loadOrderInfo
    },
    dispatch,
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(InvoiceLayout));
